import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

export interface useCorretoresEmpresaVendasInterface {
  enabled?: boolean;
  // idsEmpresasVendas: string[] | undefined;
  palavraChave?: string;
  params: string;
}

export function useCorretoresEmpresaVendas(
  props: useCorretoresEmpresaVendasInterface & QueryGlobalInterface
) {
  const fetchData = async () => {
    const BUSCAR_LEAD = `dadoscomum/corretores-empresa-vendas${props?.params}`;
    const response = await instance.get(BUSCAR_LEAD);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: props.enabled ?? false,
    onError: () => {
      toast.error("Erro ao buscar corretores.");
    },
  });
  return query;
}
